import { Text } from "@seneca/senekit";

type Props = {
  teacherName: string;
};

export default function EmailInvitationTemplate({ teacherName }: Props) {
  return (
    <>
      <Text>
        Hi [parent name],
        <br /> <br />
        {teacherName} has invited you to check out [child name]'s homework
        progress on Seneca. Click here to accept {teacherName}'s invitation and
        stay in the loop with [child name]'s schoolwork.
        <br /> <br />
        Kind regards,
        <br />
        The Seneca Team
      </Text>
      <br />
      <Text size="small">
        You can unsubscribe or update your preferences in settings. <br />
        senecalearning.com
      </Text>
    </>
  );
}
